import React, { useEffect, useRef } from 'react';
import CardStory from './CardStory';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOurStoryData } from '../../features/OurStory/ourStory';
import { useTranslation } from 'react-i18next';

function OurStory() {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  useEffect(() => { dispatch(fetchOurStoryData()) }, [dispatch, i18n.language]);
  const { ourstory } = useSelector((state) => state.ourStory);
  return (
    <div className="mx-auto mt-40 md:mt-32 sm:mt-20 px-4 w-11/12 max-w-6xl group">
      <div className="flex flex-col items-center space-y-8">
        {/* Story Card */}
        <div className="w-full flex justify-center">
          <CardStory story={ourstory} t={t} />
        </div>

        {/* Video Card */}
        <div className="relative w-full max-w-4xl mx-auto overflow-hidden rounded-2xl border border-gray-200 shadow-lg bg-gray-100 transition-all duration-300 hover:shadow-2xl">
          <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
            <iframe
              src={ourstory?.video_url}
              className="absolute top-0 left-0 w-full h-full rounded-2xl"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>


      </div>
    </div>

  );
}

export default OurStory;
